import script from "./UserRoleCell.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRoleCell.vue?vue&type=script&setup=true&lang=js"

import "./UserRoleCell.vue?vue&type=style&index=0&id=6b0228a2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b0228a2"]])

export default __exports__